import {
  FETCH_PATIENTS_SUCCESS,
  FETCH_PATIENTS_FAILED,
  SET_PATIENT_INFO_NULL,
  FETCH_PATIENT_DATA_LOADING,
  FETCH_PATIENT_DATA_SUCCESS,
  FETCH_PATIENT_DATA_FAILED,
  ADD_NEW_PATIENT,
  ADD_NEW_PATIENT_SUCCESS,
  ADD_NEW_PATIENT_FAILED,
  RESET_NEW_PATIENT_RESPONSE,
  UPDATE_PATIENT,
  UPDATE_PATIENT_SUCCESS,
  UPDATE_PATIENT_FAILED,
  UPDATE_PATIENT_DETAILS,
  UPDATE_PATIENT_DETAILS_SUCCESS,
  UPDATE_PATIENT_DETAILS_FAILED,
  UPLOAD_PATIENT_REPORT,
  UPLOAD_PATIENT_REPORT_SUCCESS,
  UPLOAD_PATIENT_REPORT_FAILED,
  FETCH_PATIENT_COMMENT,
  FETCH_PATIENT_COMMENT_SUCCESS,
  FETCH_PATIENT_COMMENT_FAILED,
  UPDATE_PATIENT_COMMENT,
  DELETE_PATIENT_COMMENT,
  UPDATE_PATIENT_COMMENT_SUCCESS,
  DELETE_PATIENT_COMMENT_SUCCESS,
  FETCH_DISEASE_LIST_SUCCESS,
  FETCH_PATIENT_DISEASE,
  FETCH_PATIENT_DISEASE_SUCCESS,
  FETCH_CHECKUP_DATES,
  FETCH_CHECKUP_DATES_SUCCESS,
  ADD_CHECKUP_DATE,
  ADD_CHECKUP_DATE_SUCCESS,
  ADD_CHECKUP_DATE_FAILED,
  CHECKUP_MARK_AS_COMPLETE,
  CHECKUP_MARK_AS_COMPLETE_SUCCESS,
  CHECKUP_MARK_AS_COMPLETE_FAILED,
  FETCH_PATIENTS_SUMMARY,
  FETCH_PATIENTS_SUMMARY_SUCCESS,
  FETCH_PATIENTS_SUMMARY_FAILED,
  // FETCH_PATIENTS_RII_SUMMARY,
  // FETCH_PATIENTS_RII_SUMMARY_SUCCESS,
  // FETCH_PATIENTS_RII_SUMMARY_FAILED,
  GENERATE_PATIENT_ID,
  GENERATE_PATIENT_ID_SUCCESS,
  GENERATE_PATIENT_ID_FAILED,
  TOGGLE_PATIENT_STATUS,
  TOGGLE_PATIENT_STATUS_SUCCESS,
  TOGGLE_PATIENT_STATUS_FAILED,
  RESET_NEW_PATIENT_VALIDATION,
  FETCH_PATIENT_MEDICATION_SYMPTOMS_HISTORY,
  FETCH_PATIENT_MEDICATION_SYMPTOMS_HISTORY_SUCCESS,
  FETCH_PATIENT_MEDICATION_SYMPTOMS_HISTORY_FAILED,
  RESET_REPORT_ERROR,
  FETCH_PATIENTS_QNA,
  FETCH_PATIENTS_QNA_FAILED,
  FETCH_PATIENTS_QNA_SUCCESS,
  GENERATE_REPORT_SUCCESS,
  GENERATE_REPORT_FAILED,
  GENERATE_AUTOMATED_REPORT_DATA,
  // FETCH_PATIENTS_RII_SUMMARY,
  // FETCH_PATIENTS_RII_SUMMARY_SUCCESS,
  // FETCH_PATIENTS_RII_SUMMARY_FAILED,
} from "constants/ActionTypes";
//import { isNotEmpty } from "util/helpers";

const initial_state = {
  automated_report_url: "",
  automated_report_failure_msg: "",
  patients_list: [],
  sample_patient_list: [],
  fetching: false,
  error: null,
  is_error: false,
  patient_info: null,
  device_info: null,
  is_patient_added: false,
  updating_patients_details: false,
  fetching_comment: false,
  fetch_comment_data: [],
  fetch_disease_list_data: [],
  ahi_value: [],
  add_checkup_date: false,
  data_fetching: false,
  updated_patient_details: false,
  patient_medication_symptoms_history: {},
  fetch_patients_summary_gsd: {},
};

const patients_reducer = (state = initial_state, action) => {
  switch (action.type) {
    case FETCH_PATIENT_MEDICATION_SYMPTOMS_HISTORY: {
      return {
        ...state,
      };
    }
    case FETCH_PATIENT_MEDICATION_SYMPTOMS_HISTORY_SUCCESS: {
      return {
        ...state,
        patient_medication_symptoms_history: action.payload,
      };
    }
    case FETCH_PATIENT_MEDICATION_SYMPTOMS_HISTORY_FAILED: {
      return {
        ...state,
        patient_medication_symptoms_history: {},
      };
    }
    case FETCH_PATIENTS_SUCCESS: {
      let uniqueList = [],
        sp_newList = [],
        widgetList = [];

      if (action.payload.widget) {
        widgetList = action.payload.widget;
      }

      if (widgetList.length > 0) {
        state.patients_list.forEach((p) => {
          widgetList.some((w) => {
            if (p.patient_code === w.patient_code) {
              p.unread_data_nights = w.unread_data_nights || 0;
              uniqueList.push(p);
            }
            return p.patient_code === w.patient_code;
          });
        });
      }

      sp_newList =
        action.payload.length > 1 &&
        action.payload.filter((sp) => {
          return sp.created_by === 2112;
        });
      return {
        ...state,
        widget_data_list: widgetList.length > 0 ? widgetList : [],
        patients_list: uniqueList.length > 0 ? uniqueList : action.payload,
        sample_patient_list: sp_newList,
        fetching: false,
      };
    }
    case FETCH_PATIENTS_FAILED: {
      return {
        ...state,
        is_error: true,
        error: action.error,
        fetching: false,
      };
    }
    case SET_PATIENT_INFO_NULL: {
      return {
        ...state,
        patient_info: null,
      };
    }
    case FETCH_PATIENT_DATA_LOADING: {
      return {
        ...state,
        data_fetching: action.payload,
      };
    }
    case FETCH_PATIENT_DATA_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        data_fetching: false,
      };
    }
    case FETCH_PATIENT_DATA_FAILED: {
      return {
        ...state,
        is_error: true,
        error: action.error,
        fetching: false,
        data_fetching: false,
      };
    }
    case ADD_NEW_PATIENT: {
      return {
        ...state,
        is_patient_added: false,
        is_adding_patient: true,
      };
    }
    case ADD_NEW_PATIENT_SUCCESS: {
      return {
        ...state,
        is_patient_added: true,
        is_adding_patient: false,
      };
    }
    case ADD_NEW_PATIENT_FAILED: {
      return {
        ...state,
        is_patient_added: false,
        error: action.error,
        is_adding_patient: false,
      };
    }
    case RESET_NEW_PATIENT_RESPONSE: {
      return {
        ...state,
        is_patient_added: false,
        fetching: false,
        error: "",
      };
    }
    case GENERATE_PATIENT_ID: {
      return {
        ...state,
      };
    }
    case GENERATE_PATIENT_ID_SUCCESS: {
      return {
        ...state,
        generated_id: action.code,
      };
    }
    case GENERATE_PATIENT_ID_FAILED: {
      return {
        ...state,
      };
    }
    case UPDATE_PATIENT: {
      return {
        ...state,
        ...action.payload,
        updating_patients_details: true,
        alertMessage: "Patient's details updated",
      };
    }
    case UPDATE_PATIENT_SUCCESS: {
      return {
        ...state,
        updating_patients_details: false,
      };
    }
    case UPDATE_PATIENT_FAILED: {
      return {
        ...state,
        is_error: true,
        error: action.error,
        updating_patients_details: false,
        fetching_comment: false,
      };
    }

    case UPDATE_PATIENT_DETAILS: {
      return {
        ...state,
        ...action.payload,
        updating_patients_details: true,
      };
    }
    case UPDATE_PATIENT_DETAILS_SUCCESS: {
      return {
        ...state,
        updated_patient_details: { ...action.message },
        updating_patients_details: false,
      };
    }
    case UPDATE_PATIENT_DETAILS_FAILED: {
      return {
        ...state,
        error: action.error,
        updating_patients_details: false,
      };
    }

    case UPLOAD_PATIENT_REPORT: {
      return {
        ...state,
        ...action.payload,
        uploading_patient_report: true,
        // alertMessage: "Patient's details updated",
      };
    }
    case UPLOAD_PATIENT_REPORT_SUCCESS: {
      return {
        ...state,
        uploading_patient_report: false,
      };
    }
    case UPLOAD_PATIENT_REPORT_FAILED: {
      return {
        ...state,
        is_error: true,
        error: action.error,
        uploading_patient_report: false,
        // fetching_comment: false
      };
    }

    case RESET_REPORT_ERROR: {
      return {
        ...state,
        is_error: false,
        error: null,
      };
    }

    case FETCH_PATIENT_COMMENT: {
      return {
        ...state,
        ...action.payload,
        fetching_comment: true,
      };
    }
    case FETCH_PATIENT_COMMENT_SUCCESS: {
      return {
        ...state,
        fetch_comment_data: action.payload,
        fetching_comment: false,
      };
    }
    case FETCH_PATIENT_COMMENT_FAILED: {
      return {
        ...state,
        fetch_comment_data: [],
        fetching_comment: false,
      };
    }
    case UPDATE_PATIENT_COMMENT: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case UPDATE_PATIENT_COMMENT_SUCCESS: {
      return {
        ...state,
      };
    }
    case DELETE_PATIENT_COMMENT: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case DELETE_PATIENT_COMMENT_SUCCESS: {
      return {
        ...state,
      };
    }
    case FETCH_DISEASE_LIST_SUCCESS: {
      return {
        ...state,
        fetch_disease_list_data: action.data,
      };
    }
    case FETCH_PATIENT_DISEASE: {
      return {
        ...state,
      };
    }
    case FETCH_PATIENT_DISEASE_SUCCESS: {
      return {
        ...state,
        fetch_patient_diseases_data: action.data,
      };
    }
    case FETCH_CHECKUP_DATES: {
      return {
        ...state,
      };
    }
    case FETCH_CHECKUP_DATES_SUCCESS: {
      return {
        ...state,
        fetch_checkup_dates: action.data,
      };
    }
    case ADD_CHECKUP_DATE: {
      return {
        ...state,
      };
    }
    case ADD_CHECKUP_DATE_SUCCESS: {
      return {
        ...state,
        add_checkup_date: true,
      };
    }
    case ADD_CHECKUP_DATE_FAILED: {
      return {
        ...state,
        add_checkup_date: false,
      };
    }
    case CHECKUP_MARK_AS_COMPLETE: {
      return {
        ...state,
      };
    }
    case CHECKUP_MARK_AS_COMPLETE_SUCCESS: {
      return {
        ...state,
      };
    }
    case CHECKUP_MARK_AS_COMPLETE_FAILED: {
      return {
        ...state,
      };
    }
    case FETCH_PATIENTS_SUMMARY: {
      return {
        ...state,
      };
    }
    case FETCH_PATIENTS_SUMMARY_SUCCESS: {
      if (action.data[0] && action.data[0].kpi === "GSD") {
        return {
          ...state,
          fetch_patients_summary_gsd: action.data,
          fetch_patients_summary_data: action.data,
        };
      }

      return {
        ...state,
        fetch_patients_summary_data: action.data,
      };
    }

    case FETCH_PATIENTS_SUMMARY_FAILED: {
      return {
        ...state,
      };
    }
    // case FETCH_PATIENTS_RII_SUMMARY: {
    //     return {
    //         ...state,
    //     };
    // }
    // case FETCH_PATIENTS_RII_SUMMARY_SUCCESS: {
    //     return {
    //         ...state,
    //         fetch_patients_rii_summary_data: action.payload
    //     };
    // }

    // case FETCH_PATIENTS_RII_SUMMARY_FAILED: {
    //     return {
    //         ...state,
    //     };
    // }

    case TOGGLE_PATIENT_STATUS: {
      return {
        ...state,
        past_patient_success: undefined,
      };
    }
    case TOGGLE_PATIENT_STATUS_SUCCESS: {
      return {
        ...state,
        past_patient_success: action.data,
      };
    }
    case TOGGLE_PATIENT_STATUS_FAILED: {
      return {
        ...state,
        error: action.error,
      };
    }
    case RESET_NEW_PATIENT_VALIDATION: {
      return {
        ...state,
        error: null,
        is_error: false,
      };
    }

    case FETCH_PATIENTS_QNA_SUCCESS:
      return {
        ...state,
        fetch_patients_qna_data: action.payload,
      };
    case FETCH_PATIENTS_QNA:
    case FETCH_PATIENTS_QNA_FAILED: {
      return {
        ...state,
        fetch_patients_qna_data: null,
      };
    }
    case GENERATE_REPORT_SUCCESS: {
      return {
        ...state,
        automated_report_url: action.data,
      };
    }
    case GENERATE_REPORT_FAILED: {
      return {
        ...state,
        automated_report_failure_msg: action.data,
      };
    }
    case GENERATE_AUTOMATED_REPORT_DATA: {
      return {
        ...state,
        automated_report_failure_msg: "",
        automated_report_url: "",
      };
    }

    default:
      return state;
  }
};

export default patients_reducer;
